<template>
  <template v-if="!isLoadError">
    <plain-form :can-back="true" @submit.prevent="doRegister" @back="toList">
      <vuex-email-form-item bind="email" label="メールアドレス" />
      <template #submit-button>
        <invite-button class="px-5" />
      </template>
    </plain-form>
    <info-toast ref="flashMessageToast" />
    <message-error-toast ref="serverErrorToast" />
  </template>
  <template v-else>
    <plain-form>
      <div v-if="isLoadErrorGone">
        <p>統合依頼できません。</p>
        <p>統合先の管理者のメールアドレスを指定してください。</p>
      </div>
      <div v-else-if="isLoadErrorConflict">
        <p>別の統合依頼が存在するため、登録できません。</p>
        <p>現在の統合依頼を承認、または、拒否してください。</p>
      </div>
      <div v-else-if="isForbidden">
        <p>統合依頼できません。</p>
        <p>統合先の管理者のメールアドレスを指定してください。</p>
      </div>
    </plain-form>
  </template>
</template>

<script>
import AddonLoadPageEvent from '@/mixin/AddonLoadPageEvent';
import InviteButton from '@/views/molecules/buttons/InviteButton';
import VuexEmailFormItem from "@/views/molecules/formItems/VuexEmailFormItem";
import PlainForm from '@/views/templates/forms/PlainForm';
import InfoToast from '@/views/molecules/toast/InfoToast';
import MessageErrorToast from '@/views/molecules/toast/MessageErrorToast';

import { mapState }  from "vuex";
export default {
  name: "MergerRequestRegister",
  components: {
    VuexEmailFormItem,
    InviteButton,
    PlainForm,
    InfoToast,
    MessageErrorToast
  },
  mixins: [AddonLoadPageEvent],
  provide: {
    bindModule: 'merger_request_register_form'
  },
  computed: {
    ...mapState('merger_request_register_form', {
      isLoadErrorConflict: state => state.isLoadErrorConflict,
      isLoadErrorGone: state => state.isLoadErrorGone,
      isForbidden: state => state.isForbidden,
    }),
    isLoadError() {
      return this.isLoadErrorConflict || this.isLoadErrorGone || this.isForbidden;
    },
  },
  mounted() {
    this.$store.commit('merger_request_register_form/resetData');
    this.$store.commit('merger_request_register_form/clearError');
  },
  methods: {
    doRegister() {
      this.$store.dispatch('merger_request_register_form/validate').then(() => {
        this.$store.dispatch('merger_request_register_form/register')
        .then(() => this.$refs.flashMessageToast.show('送信しました'))
        .catch(reason => this.$root.failApi(reason));
      })
    },
    toList() {
      this.$router.push({ name: 'BrokerageCompanyViewer' });
    },
  }
}
</script>
